import { createElement, FC, Fragment } from 'react';

export const CurrentYear: FC = () => {
  const year = new Date(Date.now()).getFullYear();
  return <Fragment>{year}</Fragment>;
};
